import Blockly from 'blockly/browser'
import { defineBlock } from '../Util'

defineBlock(
  'sirenia_api_xml_load',
  {
    message0: 'parsed xml %1',
    args0: [
      {
        type: 'input_value',
        name: 'XML_TEXT'
      }
    ],
    output: null,
    tooltip: 'Creates xml document from xml string',
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#load-xml'
  },
  function(block) {
    var xmlText =
      Blockly.JavaScript.valueToCode(block, 'XML_TEXT', Blockly.JavaScript.ORDER_ATOMIC) || `''`
    var code = `Xml.load(${xmlText})`
    return [code, Blockly.JavaScript.ORDER_ATOMIC]
  }
)

defineBlock(
  'sirenia_api_xml_load_from',
  {
    message0: 'parsed xml from url %1',
    args0: [
      {
        type: 'input_value',
        name: 'XML_URL'
      }
    ],
    output: null,
    tooltip: 'Creates xml document from url pointing to xml file',
    helpUrl:
      'http://sirenia.eu/product/configuration-interface/documentation/flows/#load-xml-from-url'
  },
  function(block) {
    var xmlUrl =
      Blockly.JavaScript.valueToCode(block, 'XML_URL', Blockly.JavaScript.ORDER_ATOMIC) || `''`
    var code = `Xml.loadFrom(${xmlUrl})`
    return [code, Blockly.JavaScript.ORDER_ATOMIC]
  }
)
